import * as React from 'react';

import { cn } from '../../lib/cn';
import { Avatar, AvatarImage, AvatarFallback } from '../Avatar';

// Avatar with a presence dot. `online` is tri-state: null hides the dot rather than
// asserting someone is offline.
export const PresenceAvatar = React.forwardRef(
  ({ className, size = 40, name, initials, src, online = null, ...props }, ref) => (
    <span ref={ref} className={cn('relative shrink-0', className)} {...props}>
      <Avatar className="h-full w-full" style={{ width: size, height: size }}>
        {src && <AvatarImage src={src} alt={name || ''} />}
        <AvatarFallback className="bg-dusq-grey900 font-dusq font-bold text-dusq-grey400">
          {initials}
        </AvatarFallback>
      </Avatar>
      {online !== null && (
        <span
          className={cn(
            'absolute bottom-0 right-0 h-2 w-2 rounded-full border-2 border-dusq-surface',
            online ? 'bg-dusq-positive' : 'bg-dusq-grey600'
          )}
        />
      )}
    </span>
  )
);
PresenceAvatar.displayName = 'PresenceAvatar';
